var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";
import { BaseOrganizationDto, BaseOrganizationPublicProfileDto } from "./organization.dtos";
import { UserType } from "./user.dtos";
const _INGEST_TYPE_VALUES = ["epic", "bundle", "bulk"];
export const INGEST_TYPE_VALUES = [..._INGEST_TYPE_VALUES];
export function asIngestType(input) {
    if (INGEST_TYPE_VALUES.includes(input)) {
        return input;
    }
    else {
        return null;
    }
}
export var GFIDProvider;
(function (GFIDProvider) {
    GFIDProvider["SMART_ON_FHIR"] = "SMART_ON_FHIR";
    GFIDProvider["CLEAR"] = "CLEAR";
})(GFIDProvider || (GFIDProvider = {}));
export class HealthcareOrganizationPublicProfileDto extends BaseOrganizationPublicProfileDto {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], HealthcareOrganizationPublicProfileDto.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalName", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationPublicProfileDto.prototype, "allowDataAccessForPatientIdentification", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationPublicProfileDto.prototype, "allowDataAccessForDataDelivery", void 0);
__decorate([
    IsEnum(GFIDProvider, { each: true }),
    __metadata("design:type", Array)
], HealthcareOrganizationPublicProfileDto.prototype, "patientAuthenticationProviders", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationPublicProfileDto.prototype, "forcePatientPortalEmbed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalWebLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalMobileAppLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalIosAppInstallUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalAndroidAppInstallUrl", void 0);
export class HealthcareOrganizationDto extends BaseOrganizationDto {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "agentBaseUrl", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationDto.prototype, "agentIsHealthExManaged", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationDto.prototype, "allowDataAccessForPatientIdentification", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationDto.prototype, "allowDataAccessForDataDelivery", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], HealthcareOrganizationDto.prototype, "primaryContactName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], HealthcareOrganizationDto.prototype, "primaryContactEmail", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "primaryContactPhone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "patientPortalName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "patientPortalLink", void 0);
__decorate([
    IsEnum(GFIDProvider, { each: true }),
    __metadata("design:type", Array)
], HealthcareOrganizationDto.prototype, "patientAuthenticationProviders", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationDto.prototype, "require21CFRPart11ForInformedConsents", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationDto.prototype, "defaultRequire21CFRPart11ForInformedConsents", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "pairingCode", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], HealthcareOrganizationDto.prototype, "forcePatientPortalEmbed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "patientPortalWebLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "patientPortalMobileAppLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "patientPortalIosAppInstallUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationDto.prototype, "patientPortalAndroidAppInstallUrl", void 0);
export class HealthcareOrganizationPatientFacingDto extends HealthcareOrganizationPublicProfileDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], HealthcareOrganizationPatientFacingDto.prototype, "primaryContactName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], HealthcareOrganizationPatientFacingDto.prototype, "primaryContactEmail", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPatientFacingDto.prototype, "primaryContactPhone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationPatientFacingDto.prototype, "patientPortalLink", void 0);
export class CreateHealthcareOrganizationInput extends PickType(HealthcareOrganizationDto, ["name"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], CreateHealthcareOrganizationInput.prototype, "type", void 0);
export class UpdateHealthcareOrganizationInput extends PartialType(PickType(HealthcareOrganizationDto, ["name"])) {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateHealthcareOrganizationInput.prototype, "type", void 0);
export class UpdateHealthcareOrganizationDetailsInput extends PartialType(OmitType(HealthcareOrganizationDto, ["id", "name", "onChainAddress", "adminEmail"])) {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateHealthcareOrganizationDetailsInput.prototype, "type", void 0);
